import { Injectable } from "@angular/core";

import * as _ from "lodash";

import { AuthStore } from "@api/store/auth";
import { ProfileDto } from "@api/dto";

import { HttpService } from "./http.service";

@Injectable()
export class AuthService {
  constructor(private httpService: HttpService, private authStore: AuthStore) {}

  async current() {
    const user = await this.httpService.get<ProfileDto>("/v1/profile");
    const authUser = _.clone(user);

    this.authStore.update({ user: authUser });

    return user;
  }

  async isMerchant() {
    return await this.httpService.get<Boolean>("/merchant/v1/is-merchant");
  }

  async isAdmin() {
    return await this.httpService.get<Boolean>("/admin/v1/is-admin");
  }

  async updatePassword(currentPassword: string, newPassword: string) {
    return await this.httpService.patch<Boolean>("/auth/v1/update-password", {
      currentPassword,
      newPassword,
    });
  }

  async logIn(email: string, password: string, rememberMe: boolean) {
    const { sessionToken, user } = await this.httpService.post<any>(
      "/auth/v1/login",
      { email, password, rememberMe }
    );

    await this.httpService.setSessionToken(sessionToken, rememberMe);

    return user;
  }

  async logOut() {
    await this.httpService.delete("/auth/v1/logout");

    return await this.httpService.removeSessionToken();
  }
}
